import { FunctionComponent } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { InvoiceListRecord } from '@spike/invoice-model';
import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { mediaQueries } from 'hooks/useBreakpoints';
import styles from './IssueInvoiceModal.module.scss';

export interface IssueInvoiceModalProps {
    invoice: InvoiceListRecord | null;
    issuing?: boolean;
    zIndex?: number;
    onClose: () => void;
    onConfirm: () => void;
}

const IssueInvoiceModalContent: FunctionComponent<{
    issuing?: boolean;
    zIndex?: number;
    onClose: () => void;
    onConfirm: () => void;
}> = ({ issuing = false, zIndex, onClose, onConfirm }) => {
    const isMobile = useMediaQuery(`(max-width:${mediaQueries.down.sm})`);

    return (
        <GenericModal
            fullScreen={isMobile}
            zIndex={zIndex}
            onClose={issuing ? undefined : onClose}
            footer={
                <div className={styles.footer}>
                    <div className={styles.footerAction}>
                        <Button
                            size="large"
                            className={styles.button}
                            label="Cancel"
                            onClick={onClose}
                            variant="black"
                            disabled={issuing}
                        />
                    </div>
                    <div className={styles.footerAction}>
                        <Button
                            label={issuing ? 'Issuing...' : 'Issue'}
                            size="large"
                            className={styles.button}
                            onClick={onConfirm}
                            variant="green"
                            isLoading={issuing}
                            disabled={issuing}
                        />
                    </div>
                </div>
            }
            className={styles.modal}
        >
            <div className={styles.content}>
                <span className={styles.title}>Issue Invoice?</span>
                <p className={styles.description}>Are you sure you want to issue this invoice now?</p>
            </div>
        </GenericModal>
    );
};

export const IssueInvoiceModal: FunctionComponent<IssueInvoiceModalProps> = ({
    invoice,
    issuing,
    zIndex,
    onClose,
    onConfirm
}) => {
    if (!invoice) {
        return null;
    }

    return (
        <IssueInvoiceModalContent
            key={invoice.uuid}
            issuing={issuing}
            zIndex={zIndex}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default IssueInvoiceModal;
